import React from 'react';
import ComponentHelper from '../../../supers/ComponentHelper';
import './connection-list.css';
import RESTService from '../../../services/RESTService';
import RoutingService from '../../../services/RoutingService';
import ListPanel from '../../../components/list-panel/ListPanel';
import TimeAgo from '../../../../node_modules/react-timeago/lib/index';
import restImg from '../connection-creator/rest.png';
import ex10 from '../connection-creator/e2010.png';
import exchange from '../connection-creator/exchange.png';
import htmlImg from '../connection-creator/html.png';
import soapImg from '../connection-creator/soap.png';
import sqlImg from '../connection-creator/sql.png';
import CommonService from '../../../services/CommonService';
import Spinner from '../../../components/spinner/Spinner';
import DialogModal from '../../../components/dialog-modal/DialogModal';
import CloneModal from '../../../components/clone-modal/CloneModal';
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();
class ConnectionList extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			connections: [],
			loading: true,
			searchText: '',
			toClone: {},
			showClone: false,
			showDeleteModal: false,
			connMap: {}
		};
	}

	componentDidMount() {
		connect
			.getConnections()
			.then(res => {
				this.observe(() => {
					this.data.connections = res.data;
					this.data.connMap = CS.mapByParam('_id', res.data);
					this.data.loading = false;
				});
			})
			.catch(err => {
				this.setData('loading', false);
				RS.smartError(err);
			});
	}

	onSearchChange = evt => {
		this.setData('searchText', evt.target.value);
	};

	onCreate = () => {
		this.props.onCreateConnection();
		RS.goToRoute('/connections/create');
	};

	getConnectionImage = type => {
		switch (type) {
			case 'http-connector': {
				return restImg;
			}
			case 'soap-connector': {
				return soapImg;
			}
			case 'ews-exchange-connector': {
				return exchange;
			}
			case 'exchange-connector': {
				return ex10;
			}
			case 'html-connector': {
				return htmlImg;
			}
			case 'sql-connector': {
				return sqlImg;
			}
			default: {
				return restImg;
			}
		}
	};

	onConnectionClick = evt => {
		if (evt.target.classList.contains('action') || evt.target.classList.contains('mdi')) {
			return;
		}
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let connection = this.data.connMap[id];
			if (connection) {
				connection.testing = false;
				this.props.onEditConnection(connection);
				RS.goToRoute('/connections/edit');
			}
		}
	};

	onTest = evt => {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let connection = this.data.connMap[id];
			if (connection) {
				connection.testing = true;
				this.props.onTestConnection(connection);
				RS.goToRoute('/connections/edit');
			}
		}
	};

	onDelete = evt => {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let connection = this.data.connMap[id];
			if (connection) {
				this.observe(() => {
					this.data.showDeleteModal = true;
					this.data.toDelete = connection;
				});
			}
		}
	};

	toggleDeleteModal = () => {
		this.setData('showDeleteModal', !this.data.showDeleteModal);
	};

	onConfirmDelete = () => {
		this.toggleDeleteModal();
		let connection = this.data.toDelete;
		if (connection) {
			connect
				.deleteConnection(connection.name)
				.then(() => {
					RS.showSuccess();
					this.componentDidMount();
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	};

	buildConnectionList = () => {
		let cons = this.data.connections;
		cons = cons.filter(connection => {
			return connection.name.indexOf(this.data.searchText) >= 0;
		});
		if (this.data.loading) {
			return <Spinner height="400px" text="Loading Connections" />;
		} else if (cons.length <= 0 && this.data.searchText.length <= 0) {
			return <div className="empty-list">Your application has no connections yet.</div>;
		} else if (cons.length <= 0 && this.data.searchText.length > 0) {
			return <div className="empty-list">No connections match your query.</div>;
		}
		let items = [];
		for (let i = 0; i < cons.length; i++) {
			let con = cons[i];
			items.push(
				<div className="list-item hbox vcenter animated fadeInDown" key={'list-item-' + con._id} data-id={con._id} onClick={this.onConnectionClick}>
					<div className="list-value ellipse grow-1">{con.name}</div>
					<div className="list-value ellipse grow-1">
						<TimeAgo date={con.updateDate ? con.updateDate : con.creationDate} />
					</div>
					<div className="list-value ellipse grow-1">
						<img src={this.getConnectionImage(con.type)} className="connection-type" alt="Connection Type" />
					</div>
					<div className="actions hbox vcenter grow-1">
						<div className="action vbox hcenter vcenter" data-rh="Clone Connection" data-rh-at="top" data-id={con._id} onClick={this.onCopy}>
							<i className="mdi mdi-content-duplicate" data-id={con._id} />
						</div>
						<div className="action vbox hcenter vcenter" data-rh="Test Connection" data-rh-at="top" data-id={con._id} onClick={this.onTest}>
							<i className="mdi mdi-mixcloud" data-id={con._id} />
						</div>
						<div className="action vbox hcenter vcenter" data-rh="Delete Connection" data-rh-at="top" data-id={con._id} onClick={this.onDelete}>
							<i className="mdi mdi-delete" data-id={con._id} />
						</div>
					</div>
				</div>
			);
		}
		return items;
	};

	onCopy = evt => {
		let id = evt.currentTarget.dataset.id;
		if (id) {
			let con = this.data.connMap[id];
			if (con) {
				this.observe(() => {
					this.data.toClone = con;
					this.data.showClone = true;
				});
			}
		}
	};

	cloneConnection = name => {
		let newConn = JSON.parse(JSON.stringify(this.data.toClone));
		newConn.name = name;
		delete newConn._id;
		delete newConn.creationDate;
		this.observe(() => {
			this.data.showClone = false;
			this.data.loading = true;
		});
		connect
			.createConnection(newConn)
			.then(() => {
				this.observe(() => {
					this.data.loading = false;
					this.componentDidMount();
				});
			})
			.catch(err => {
				RS.smartError(err);
				this.observe(() => {
					this.data.showClone = false;
					this.data.loading = true;
				});
			});
	};

	toggleCloneModal = () => {
		this.setData('showClone', !this.data.showClone);
	};

	render() {
		return [
			<div className="connection-list-header hbox vcenter hright">
				<div className="search-ctn hbox vcenter">
					<i className="mdi mdi-magnify" />
					<input className="search-input" value={this.data.searchText} onChange={this.onSearchChange} placeholder="Search Connections..." />
				</div>
			</div>,
			<ListPanel
				name="Connections List"
				className="connection-list-view"
				labels={['name', 'updated', 'type', 'actions']}
				onCreate={this.onCreate}
				listItems={this.buildConnectionList()}
			/>,
			<CloneModal
				isOpen={this.data.showClone}
				onCancel={this.toggleCloneModal}
				cloneObject={this.cloneConnection}
				toClone={this.data.toClone}
				title="Clone Connection"
			/>,
			<DialogModal
				isOpen={this.data.showDeleteModal}
				type="warning"
				showCancelButton={true}
				cancelBtnText="Cancel"
				confirmBtnText="Delete"
				text="Deleting a connection cannot be undone"
				title="Are you sure?"
				onConfirm={this.onConfirmDelete}
				onCancel={this.toggleDeleteModal}
			/>
		];
	}
}

export default ConnectionList;



// WEBPACK FOOTER //
// ./src/views/connections-panel/connection-list/ConnectionList.js